function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.875 6.075a.601.601 0 00-.475-.233h-3.684V3.716A3.72 3.72 0 008 0a3.72 3.72 0 00-3.716 3.716v2.126H.6a.6.6 0 00-.58.752l2.336 8.958a.6.6 0 00.58.448h10.127a.6.6 0 00.581-.449l2.337-8.957a.604.604 0 00-.106-.519zM5.484 3.716A2.519 2.519 0 018 1.2a2.519 2.519 0 012.516 2.516v2.126H5.484V3.716zM12.6 14.8H3.4L1.377 7.042h2.908V8a.6.6 0 001.2 0v-.958h5.031V8a.6.6 0 001.2 0v-.958h2.908L12.6 14.8z",
  fill: "#23448D"
})));